import { useEffect } from "react";
import { useLocation, useMatches } from "react-router";
import { ProfileReorderPartialPopup } from "./profile.reorder-partial-popup.component";
import {
	consumeReorderPartialFromNavigation,
	dismissReorderPartialFromNavigation,
	shouldRevealReorderPartialPopup,
} from "./reorder-partial-from-navigation";
import { useReorderPopupSnackbar } from "./use-reorder-popup-snackbar.hook";

export function ReorderPartialFromNavigation() {
	const location = useLocation();
	const matches = useMatches();
	const routeId = matches.at(-1)?.id ?? "";
	const { isVisible, show, dismiss, pauseAutoDismiss, resumeAutoDismiss } =
		useReorderPopupSnackbar(
			"da:reorder-partial",
			dismissReorderPartialFromNavigation,
		);

	useEffect(() => {
		if (!shouldRevealReorderPartialPopup(location.pathname, routeId)) {
			dismissReorderPartialFromNavigation();
			dismiss();
			return;
		}
		if (consumeReorderPartialFromNavigation()) {
			show();
		}
	}, [dismiss, location.pathname, routeId, show]);

	return (
		<ProfileReorderPartialPopup
			open={isVisible}
			onDismiss={() => {
				dismissReorderPartialFromNavigation();
				dismiss();
			}}
			onMouseEnter={pauseAutoDismiss}
			onMouseLeave={resumeAutoDismiss}
		/>
	);
}
